{
  "loading": "Chargement en cours…",
  "loadingMore": "Chargement d’autres d’éléments…"
}
